import axiosInstance from './saas-request';

export default {
	//查询组织架构树(带不含人员)
	selOrganizationTree({ ...params }) {
		return axiosInstance.post({
			url: "/usercenter/organization/version/selOrganizationTree",
			data: params
		})
	},
	// 查询组织架构树(带权限不含人员)
	selAuthOrganizationTree({ ...params }) {
		return axiosInstance.get({
			url: "/usercenter/organization/version/selAuthOrganizationTree",
			params,
		});
	},
	//分页查询员工列表
	queryPersonList({ ...params }) {
		return axiosInstance.post({
			url: "/usercenter/person/queryPersonList",
			data: params
		})
	},
	//批量查询人员基本信息
	queryBaseInfoBatch({ ...params }) {
		return axiosInstance.post({
			url: "/usercenter/person/queryBaseInfoBatch",
			data: params,
		});
	},
	//查询人员职务列表
	queryPersonJob({ ...params }) {
		return axiosInstance.get({
			url: "/usercenter/person/queryPersonJob",
			params: params
		})
	},
	//查询部门列表（分页）
	selOrganizationDepartList({ ...params }) {
		return axiosInstance.post({
			url: "/usercenter/organization/depart/selOrganizationDepartList",
			data: params
		})
	}
}
